var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql, useQuery } from '@apollo/client';
// CURRENT_USER
var CURRENT_USER = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  query CurrentUser {\n    current_user {\n      id\n      full_name\n      email\n      teams {\n        id\n        name\n        permissions\n      }\n    }\n  }\n"], ["\n  query CurrentUser {\n    current_user {\n      id\n      full_name\n      email\n      teams {\n        id\n        name\n        permissions\n      }\n    }\n  }\n"])));
export var useCurrentUserQuery = function (options) {
    return useQuery(CURRENT_USER, options);
};
export default CURRENT_USER;
var templateObject_1;
